import React, { useState } from 'react';
import { defineMessages } from 'react-intl';
import { generatePath, useNavigate, useParams } from 'react-router-dom';
import PageWrapper from '@components/common/layout/PageWrapper';
import apiConfig from '@constants/apiConfig';
import { errorCodes } from '@constants/ErrorCode';
import useSaveBase from '@hooks/useSaveBase';
import useTranslate from '@hooks/useTranslate';
import { commonMessage } from '@locales/intl';
import routes from '@routes';
import { showErrorMessage } from '@services/notifyService';

import DeviceForm from './DeviceForm';
const message = defineMessages({
    objectName: 'Device',
});

const DeviceSavePage = () => {
    const translate = useTranslate();
    const params = useParams();

    const { detail, mixinFuncs, loading, setIsChangedFormValues, isEditing, title, setSubmit } = useSaveBase({
        apiConfig: {
            getById: apiConfig.kitplayDevice.getById,
            create: apiConfig.kitplayDevice.create,
            update: apiConfig.kitplayDevice.update,
        },
        options: {
            getListUrl: generatePath(routes.kitplayDeviceManagement.path, { customerId: params.customerId }),
            objectName: translate.formatMessage(message.objectName),
        },
        override: (funcs) => {
            funcs.prepareUpdateData = (data) => {
                return {
                    ...data,
                    id: detail.id,
                };
            };
            funcs.prepareCreateData = (data) => {
                return {
                    ...data,
                };
            };
            funcs.onSaveError = (err) => {
                const errorCode = err.response?.data?.code;
                const errorMessage = errorCodes[errorCode]?.message;
                if (errorMessage) {
                    showErrorMessage(errorMessage, translate);
                    setSubmit(false);
                } else {
                    mixinFuncs.handleShowErrorMessage(err, showErrorMessage);
                    setSubmit(false);
                }
            };
        },
    });

    const pageTitle = isEditing
        ? `${translate.formatMessage(commonMessage.edit)} ${translate.formatMessage(message.objectName)}`
        : `${translate.formatMessage(commonMessage.create)} ${translate.formatMessage(message.objectName)}`;

    return (
        <PageWrapper
            routes={[
                { breadcrumbName: translate.formatMessage(commonMessage.kitPlayShop), path: routes.shopAccountListPage.path },
                {
                    breadcrumbName: translate.formatMessage(commonMessage.piService),
                    path: `${generatePath(routes.kitplayDeviceManagement.path, {
                        customerId: params.customerId,
                    })}`,
                },
                { breadcrumbName: pageTitle },
            ]}
            title={pageTitle}
        >
            <DeviceForm
                setIsChangedFormValues={setIsChangedFormValues}
                dataDetail={detail ? detail : {}}
                formId={mixinFuncs.getFormId()}
                isEditing={isEditing}
                actions={mixinFuncs.renderActions()}
                onSubmit={mixinFuncs.onSave}
            />
        </PageWrapper>
    );
};

export default DeviceSavePage;
